import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  PageState,
  PageStateService,
} from '../../../services/page-state/page-state.service';
import { Observable } from 'rxjs';
import { IconsModule } from '../../../icons/icons.module';
import { PageHeaderService } from '../../../services/page-header/page-header.service';

@Component({
  selector: 'zikatagov-page-header',
  standalone: true,
  imports: [CommonModule, IconsModule],
  template: `
    <div class="container-fluid py-3">
      <div class="row justify-content-between">
        <div class="d-flex align-items-center col">
          <h1 class="mb-0 text-primary fs-4 fw-normal">
            {{ (pageState$ | async)?.title }}
          </h1>
          <div class="vertical-separator bg-primary mx-4"></div>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0 d-inline-flex align-items-center">
              <ng-container
                *ngFor="
                  let item of (pageState$ | async)?.breadcrumb;
                  let last = last;
                  let first = first
                "
              >
                <li
                  class="breadcrumb-item text-primary fs-6 fw-normal d-flex align-items-center"
                  [class.active]="last"
                  [attr.aria-current]="last ? 'page' : null"
                >
                  {{ item }}
                </li>
                <ng-icon
                  *ngIf="!last"
                  name="saxArrowRight3Outline"
                  size="14"
                  class="text-pink d-flex align-items-center mx-2"
                ></ng-icon>
              </ng-container>
            </ol>
          </nav>
        </div>
        <div class="d-flex align-items-center col-auto">
        <ng-container *ngTemplateOutlet="rightContent$ | async"></ng-container>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .fs-4 {
        font-size: 24px !important;
      }
      .fs-6 {
        font-size: 16px !important;
      }
      .breadcrumb-item::before {
        display: none;
      }

      .vertical-separator {
        width: 1px;
        height: 28px;
      }
      .breadcrumb-item,
      .breadcrumb-item + div {
        line-height: 28px;
      }
    `,
  ],
})
export class ZikatagPageHeaderComponent {
  private pageStateService = inject(PageStateService);
  private pageHeaderService = inject(PageHeaderService);
  
  pageState$: Observable<PageState> = this.pageStateService.getPageState();
  rightContent$ = this.pageHeaderService.rightContent$;
}
